import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";
const Support = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const regions = ["South1", "South2", "South3", "West", "North", "Central"];

  const handleStatus = ({ id }) => {
    const updatedData = [...list];
    const currentStatus = updatedData[id].status || "on";
    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setList(updatedData);
    console.log("KK", id);
  };


  const MasterList = async (search) => {
    setSearchValue(search);
    const payload = {
      type: 5,
      search: search,
      pagination: page,
    }
    let res = await post(URLS.MASTERLIST, payload)
    if (res?.status == "success") {
      setList(res?.masters);
    }
  }

  useEffect(() => {
    MasterList();
  }, []);


  const statusChange = async (id) => {
    console.log("id", id);

    const payload = {
      id: id,
    }
    let res = await post(URLS.MASTERSTATUS + id, payload)
    if (res?.status == "success") {
      toast.success(res?.message)
      // setList(res?.admins);
      MasterList()
    }
  }

  const [owners, setOwners] = useState([
    { support: "Technical Assistance", description: "Software installation, configuration help", status: "on" },
    { support: "Warranty Claim", description: "Replacement and repair under warranty", status: "off" },
    { support: "Spare Parts", description: "Ordering spare parts and components", status: "on" },
    { support: "Maintenance", description: "Scheduled preventive maintenance support", status: "on" },
    { support: "Training", description: "User and technician training sessions", status: "on" },
    { support: "On-site Visit", description: "Technician visit to client site", status: "off" },
    { support: "Remote Diagnostics", description: "Remote troubleshooting assistance", status: "on" },
    { support: "Installation", description: "Product installation at customer location", status: "on" },
    { support: "Spare Request", description: "Spare request for out-of-warranty items", status: "off" },
    { support: "Customer Feedback", description: "Collecting feedback after service", status: "on" },

  ]);


  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },


      {
        Header: "Support",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js mt-2">
            <button
              onClick={() => statusChange(row.original.id)}
              className={`${value === 0 ? "deactive-icon1" : "active-icon1"
                } f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15  fs-xxl-16`}
            >
              {value === 0 ? "De-active" : "Active"}
            </button>
          </div>
        ),
      },



    ],
    []
  );
  return (
    <>
      <Topbar header={"Support"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total : {list?.length}
          </h4>
          {/* <button
            onClick={() =>
              navigate("/support-add", { state: { type: "add" } })
            }
            className="Add_btn1 f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Add
          </button> */}
        </div>
        <div className="d-flex ac-je gap-4">


          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input value={searchValue} onChange={(e) => MasterList(e.target.value)}
              type="text"
              placeholder="Search "
              style={{ border: "none", width: "200px" }}
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={false}
        />
      </div>
    </>
  );
};

export default Support;
